<template>
    <b-row no-gutters
        id="about">
        <b-col cols="1"></b-col>
        <b-col>
            <h1 class="textTitle blueBarbos">
                SOBRE NÓS
            </h1>
            <h3 class="textSubTitle blueBarbos">
                Alguma da história da nossa empresa
            </h3>
            <p class="text greyBarbos">
                A Barbosa Peixe é uma empresa familiar fundada em 1988 por dois irmãos, António e Fernando Barbosa. Localizada actualmente na DocaPesca - Armazém 1, tem apresentado um crescimento constante do qual fazem parte os nossos 16 colaboradores.
            </p>
            <!-- <p class="text greyBarbos">
                Localizada actualmente na DocaPesca - Armazém 1, tem apresentado um crescimento constante do qual fazem parte os nossos 16 colaboradores.
            </p> -->
            <p class="text greyBarbos">
                A Barbosa Peixe destaca-se na importação, exportação e no fornecimento à restauração e hotelaria de produtos frescos e congelados de alta qualidade, provenientes de qualquer parte do globo, garantindo um elevado grau nutricional.
            </p>
            <p class="text greyBarbos">
                Foi distinguida empresa <strong>PME Líder</strong> em 2015, 2016, 2017 e 2018.
            </p>
        </b-col>
        <b-col cols="1"></b-col>
    </b-row>
</template>

<script>
export default {
    name: 'AboutUs',
    props: {}
}
</script>
